import React, { createContext, useReducer, useContext } from "react";

const HttpApisContext = createContext();

const initialState = {
  settings: null,
  homePageList: null,
  standardList: null, // we are showing this as watchlist in profile section
  searchMovies: null,
  movieDetails: null,
  relatedMovies: null,
  watchlist: null,
  mobileWatch: null, // data of video source
  me: null,
  detailsData: null,
  videoSessionId: null,
  acitveMenuContext: "Home",
  loading: false,
  error: null,
  episode: null,
};

const httpApisReducer = (state, action) => {
  switch (action.type) {
    case "SET_LOADING":
      return { ...state, loading: true };
    case "SET_ERROR":
      return { ...state, loading: false, error: action.payload };
    case "SET_SETTINGS":
      return { ...state, settings: action.payload, loading: false };
    case "SET_HOME_PAGE_LIST":
      return { ...state, homePageList: action.payload, loading: false };
    case "SET_STANDARD_LIST":
      return { ...state, standardList: action.payload, loading: false };
    case "SET_SEARCH_MOVIES":
      return { ...state, searchMovies: action.payload, loading: false };
    case "SET_MOVIE_DETAILS":
      return { ...state, movieDetails: action.payload, loading: false };
    case "SET_RELATED_MOVIES":
      return { ...state, relatedMovies: action.payload, loading: false };
    case "SET_WATCHLIST":
      return { ...state, watchlist: action.payload, loading: false };
    case "SET_ME":
      return { ...state, me: action.payload, loading: false };
    case "SET_SESSION_ID":
      return { ...state, videoSessionId: action.payload, loading: false };
    case "SET_MOBILE_WATCH":
      return { ...state, mobileWatch: action.payload, loading: false };
    case "SET_ACTIVE_MENU_CONTEXT":
      return { ...state, acitveMenuContext: action.payload, loading: false };
    case "SET_DETAILS_DATA":
      return { ...state, detailsData: action.payload, loading: false };
    case "SET_EPISODE_DATA":
      return { ...state, episode: action.payload, loading: false };
    default:
      return state;
  }
};

export const HttpApisProvider = ({ children }) => {
  const [state, dispatch] = useReducer(httpApisReducer, initialState);

  return (
    <HttpApisContext.Provider value={{ state, dispatch }}>
      {children}
    </HttpApisContext.Provider>
  );
};

export const useHttpApis = () => {
  return useContext(HttpApisContext);
};
